export const getAuthLoadingStatus = (state) => {
    return state.authLoading;
};
export const getUserData = (state) => {
    return state.data;
};
